import { Injectable } from "@angular/core";
import { RegistrationFormGroupModel } from "@app/shared/models/registration-form-group.model";
import { ICustomerRegistrationRequest } from "../models/customer-registration-request.model";

@Injectable({
  providedIn: 'root'
})
export class CustomerRegistrationMapperService {

  public mapRegistrationFormToRegistrationRequestModel(customerRegistrationForm: RegistrationFormGroupModel): ICustomerRegistrationRequest {
    const customer = customerRegistrationForm.controls;
    return {
      customerFirstName: customer.customerData.controls.firstName.value,
      customerLastName: customer.customerData.controls.lastName.value,
      customerNameInfix: customer.customerData.controls.nameInfix.value,
      customerMobile: customer.customerData.controls.mobileNumber.value,
      customerGender: customer.customerData.controls.gender.value,
      customerEmail: customer.customerData.controls.email.value,
      customerPassword: customer.password.value,
      customerCountry: customer.customerData.controls.country.value
    };
  }
}
